var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$route.query.token
    ? _c("div", { staticClass: "row justify-content-center" }, [
        _c(
          "div",
          {
            staticClass: "form-container d-flex flex-column align-items-center",
          },
          [
            _c("div", { staticClass: "card bg-transparent border-0" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("h2", { staticClass: "title-text mx-auto mb-3" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("title.passwordRecovery")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ValidationObserver",
                    { ref: "observer" },
                    [
                      _c("v-input", {
                        staticClass: "d-none",
                        attrs: {
                          type: "text",
                          autocomplete: "username",
                          value: _vm.mail,
                        },
                      }),
                      _vm._v(" "),
                      _c("v-input", {
                        staticClass: "input-w-default",
                        attrs: {
                          ind: "0",
                          type: "password",
                          name: "password",
                          placeholder: _vm.$t("placeholder.newPassword"),
                          icon: _vm.$getInputIcon(_vm.password, "password"),
                          rules: { required: true, min: 6 },
                          autocomplete: "new-password",
                        },
                        on: { keyEnterUp: _vm.restore },
                        model: {
                          value: _vm.password,
                          callback: function ($$v) {
                            _vm.password = $$v
                          },
                          expression: "password",
                        },
                      }),
                      _vm._v(" "),
                      _c("v-input", {
                        staticClass: "input-w-default",
                        attrs: {
                          ind: "1",
                          type: "password",
                          name: "passwordConfirm",
                          placeholder: _vm.$t("placeholder.repeatPassword"),
                          icon: _vm.$getInputIcon(
                            _vm.passwordConfirm,
                            "password"
                          ),
                          rules: "required|confirmed:password",
                          autocomplete: "new-password",
                        },
                        on: { keyEnterUp: _vm.restore },
                        model: {
                          value: _vm.passwordConfirm,
                          callback: function ($$v) {
                            _vm.passwordConfirm = $$v
                          },
                          expression: "passwordConfirm",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "restore-button w-75 mb-2",
                      on: { click: _vm.restore },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("button.restore")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }